import { SITE_NAME } from "../constants/site";

const replaceBrand = (value, key) => {
  if (typeof value === "string") {
    if (key === "projectSmartHealth") {
      return value;
    }
    return value
      .replaceAll("臺灣智慧醫療學校", SITE_NAME)
      .replaceAll("臺灣智慧醫療學校", SITE_NAME)
      .replaceAll("Taiwan Smart Healthcare School", SITE_NAME)
      .replaceAll("Smart Healthcare School", SITE_NAME);
  }

  if (Array.isArray(value)) {
    return value.map((val) => replaceBrand(val, key));
  }

  if (value && typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value).map(([k, val]) => [k, replaceBrand(val, k)])
    );
  }

  return value;
};

const messages = {
  common: {
    loading: 'Loading content...',
    retry: 'Retry',
    all: 'All',
    submit: 'Submit',
    clearAll: 'Clear All',
    home: 'Home',
    allCourses: 'All Courses',
    fourDomains: 'Four Domain Programs',
    seminarArea: 'Seminar Area',
    notSpecified: 'Not Specified',
    pleaseLogin: 'Please Login',
    systemError: 'System error, please try again later',
    instructor: 'Instructor',
    download: 'Download',
    exportSuccess: 'Export successful',
    exportFailed: 'Export failed, please try again later',
    downloadSuccess: 'Download successful',
    certificateNotFound: 'Certificate not found',
    noPermission: 'You do not have permission to download this certificate',
    downloadFailed: 'Download failed, please try again later',
    networkError: 'Download error, please check your network connection',
    initFailed: 'Initialization failed:',
    invalidDownloadLink: 'Invalid download link',
    preparingDownload: 'Preparing download...',
    loginAgain: 'Login Again',
    levelBeginner: 'Beginner',
    levelIntermediate: 'Intermediate',
    levelAdvanced: 'Advanced',
    mandatory: 'Mandatory',
    optional: 'Optional',
    unknownError: 'Unknown error',
    to: 'to',
    dateLocale: 'en-US',
    scoreUnit: 'points',
    minutesUnit: 'minutes',
    uploadFailed: 'Upload failed',
    questionsUnit: 'questions',
    unknown: 'Unknown',
    gotIt: 'Got it',
    courseListDesc: 'This is the list of courses required for the training program. Optional courses can be selected from the',
    infoSecurityListDesc: 'This is the list of mandatory courses for the training program. Please log in to start the course.',
    area4Desc: 'This is a mandatory course for the training program. Please log in to start the course.',
    area4DescOpt: 'This is an optional course for the training program. Please log in to start the course.',
    tocLabel: 'Sections',
    scrollHint: 'Swipe left/right to view more information'
  },
  latest_news: {
    title: 'Latest News',
    all: 'All',
    announcement: 'Announcement',
    activity: 'Activity',
    read_more: 'Read More',
    register: 'Register',
    more_info: 'More Info'
  },
  activities: {
    home: 'Home',
    title: 'Latest News',
    announcement: 'Announcement',
    activity: 'Activity',
    read_more: 'Read More',
    register: 'Register',
    more_info: 'More Info',
    activity_time: 'Time',
    location: 'Location',
    register_link: 'Click to Register',
    course_link: 'Click for Details',
    not_found: 'Activity or Announcement not found',
    back_to_list: 'Back to List',
    not_open_yet: 'Registration Not Yet Open',
    ended: 'Activity Ended',
    registration_closed: 'Registration Closed'
  },
  certificate: {
    title: 'Certificate Download',
    subtitle: 'A certificate is available for each completed course',
    emptyText: 'You have not earned any certificates yet. Please continue completing courses to earn certificates!',
    of: 'of',
    userInfoError: 'Unable to get user information, please login again',
    invalidDownloadLink: 'Invalid download link',
    preparingDownload: 'Preparing download...',
    downloadSuccess: 'Certificate downloaded successfully',
    certificateNotFound: 'Certificate not found',
    downloadPermissionDenied: 'You do not have permission to download this certificate',
    downloadFailed: 'Download failed, please try again later',
    downloadNetworkError: 'Download error, please check your network connection',
    invalidCertificateData: 'No valid certificate data retrieved',
    fetchCertificateListError: 'Failed to fetch certificate list',
    certificateName: 'Certificate Name',
    instructor: 'Instructor',
    credits: 'Credits',
    completionDate: 'Completion Date',
    download: 'Download'
  },
  seminar: {
    desc: 'Seminar participants please go to the four domain programs to learn and earn credits.'
  },
  planCourses: {
    title: 'Required Courses for Call for Proposals',
    desc: 'Only eligible students can enter the course to earn credits'
  },
  examInfo: {
    title: 'Prepare for Exam',
    description: 'Please read the following exam instructions carefully before starting. You can leave by clicking "Come back next time".',
    examName: 'Exam Name',
    totalScore: 'Total Score',
    totalQuestions: 'Total Questions',
    examPeriod: 'Exam Period',
    examDuration: 'Exam Duration',
    scoringMethod: 'Scoring Method',
    questionsPerPage: 'Questions per Page',
    pageControl: 'Page Control',
    windowControl: 'Window Control',
    timeoutHandling: 'Timeout Handling',
    answerReveal: 'Answer Reveal',
    questionsPerPageFormat: '{count} questions per page',
    unlimited: 'Unlimited',
    cancelButton: 'Come back next time',
    startButton: 'Start Exam',
    loadingExamInfo: 'Preparing exam...',
    examReady: 'Exam is ready',
    examCreationFailed: 'Exam creation failed, please try again later',
    examInfoLoadFailed: 'Unable to load exam information, please retry',
    uploadFailed: 'Upload failed',
    examStartFailed: 'Failed to start exam',
    photoUploadFailed: 'Photo upload failed, specific error:'
  },
  examHistory: {
    title: 'Exam History',
    subtitle: 'View your course grades',
    emptyText: 'You have not taken any course exams yet. Please complete courses and take the exams!',
    of: 'of',
    userInfoError: 'Unable to get user information, please login again',
    pass: 'Pass',
    fail: 'Fail',
    retake: 'Retake Exam',
    backToCourse: 'Back to Course',
    courseName: 'Course Name',
    instructor: 'Instructor',
    credits: 'Credits',
    examDate: 'Exam Date',
    score: 'Score',
    passStatus: 'Pass Status',
    action: 'Action',
    invalidUserData: 'No valid user data returned',
    fetchUserInfoError: 'Failed to get user information, please login again',
    invalidExamData: 'No valid exam history data retrieved',
    fetchExamHistoryError: 'Failed to fetch exam history',
    redirectingToCourse: 'Redirecting to course page...',
    courseInfoError: 'Unable to get course information'
  },
  navbar: {
    home: 'Home',
    planOrigin: 'Plan Origin',
    seminar: 'Seminar',
    planCourses: 'CFP Requirements',
    fourDomains: 'Domain Programs',
    allCourses: 'All Courses',
    medicalInfo: 'Medical Information Program',
    medicalAI: 'Medical AI Program',
    medicalSecurity: 'Medical Security Program',
    medicalBigData: 'Medical Big Data Program',
    login: 'Login',
    register: 'Register',
    dashboard: 'My Learning',
    profile: 'Account Settings',
    editProfile: 'Edit Profile',
    inProgress: 'In Progress',
    completed: 'Completed',
    favorites: 'Favorites',
    certificates: 'Certificate Download',
    exams: 'Exams',
    logout: 'Logout',
    myCourses: 'My Courses',
    myLearningRecord: 'My Learning Record',
    myAccount: 'My Account',
    language: 'Language',
    traditionalChinese: '繁體中文',
    english: 'English',
    introAndHistory: 'Intro',
    ministerIntro: "Minister's Message",
    viceMinisterIntro: "Vice Minister's Message",
    directorIntro: "Director's Message",
    isOptional: 'Optional Courses',
    latestNews: 'Latest News',
    platformIntro: 'About Platform',
    platformBackground: 'Background',
    expertDirectory: 'Expert Directory',
    snomedCtIntro: 'RxNorm',
    whatIsSnomedCt: 'What is RxNorm',
    snomedCtEducation: 'RxNorm Education',
    rxnormIntro: 'RxNorm',
    rxnormEducation: 'RxNorm Education',
    training: 'Training & Certification',
    workshopCourses: 'Workshop Courses',
    workshopMaterials: 'Workshop Materials',
    certificationApply: 'Certification Apply',
    taiwanStandards: 'Taiwan Standards',
    standardAnnouncements: 'Standard Announcements',
    standardProposals: 'Standard Proposals',
    datasets: 'Datasets',
    terminologySearch: 'Terminology Search',
    terminologyTaiwan: 'Taiwan Version',
    terminologyInternational: 'International Version',
    supportCenter: 'Support Center',
    projectWebsites: 'Project Websites',
    projectMedStandard: '臺灣醫療資訊標準大平台',
    projectThds: '臺灣健康資料空間',
    projectThrs: '臺灣健康規則空間',
    projectThas: '臺灣健康應用空間',
    projectSnomedCt: 'SNOMED CT',
    projectLoinc: 'LOINC',
    projectRxNorm: 'RxNorm',
    projectSmartHealth: '臺灣智慧醫療學校',
    projectAiCenter: '臺灣智慧醫療三大中心',
    projectAiCenter1: '全國臨床AI應用登錄平台',
    projectAiCenter2: '全球醫療 AI 聯邦學習媒合平台'
  },
  snomedCT: {
    title: 'What Is RxNorm',
    section1: {
      title: 'What Is RxNorm'
    },
    section2: {
      title: 'How Does RxNorm Work?',
      conceptsTitle: 'Concepts:',
      descriptionsTitle: 'Descriptions:'
    }
  },
  loincIntro: {
    paragraph1:
      'RxNorm (Normalized Names for Clinical Drugs) is a standardized terminology and identifier system for clinical drugs maintained by the U.S. National Library of Medicine (NLM).',
    paragraph2:
      'It supports interoperability by linking ingredients, clinical drugs, dose forms, strengths, and branded concepts to enable consistent medication representation across systems.',
    diagramAlt: 'RxNorm concept relationships diagram'
  },
  snomedCTEducation: {
    title: 'SNOMED CT Education',
    articleTitle: 'SNOMED CT Course Videos',
    navDivider: '...',
    description: 'Want to learn more about SNOMED CT? Visit the "Seminar" section of Taiwan Smart Healthcare School to browse related course videos. No registration is required to watch them directly.',
    ctaLabel: 'Go To Taiwan Smart Healthcare School',
    application: {
      title: 'SNOMED CT Application',
      paragraph1: 'General content text in black',
      highlight: 'Special highlight text in blue',
      codeAlt: 'FHIR Patient resource example',
      codeCaption: '(Source: HL7)'
    },
    expression: {
      title: 'SNOMED CT Expression',
      paragraph1: '...'
    },
    videos: {
      title: 'SNOMED CT Course Videos',
      description: 'Want to learn more about SNOMED CT? Visit the "Seminar" section of Taiwan Smart Healthcare School to browse related course videos. No registration is required to watch them directly.',
      ctaLabel: 'Go To Taiwan Smart Healthcare School '
    }
  },
  loincEducation: {
    title: 'RxNorm Education',
    application: {
      title: 'RxNorm Application',
      paragraph1: 'RxNorm can be used in e-prescribing, EHRs, medication mapping, and cross-system exchange so the same medication can be identified consistently across data sources.',
      highlight: 'The core identifier is RxCUI (RxNorm Concept Unique Identifier), and concept relationships link ingredients, clinical drugs, and branded drugs.',
      codeAlt: 'RxNorm data example',
      codeCaption: '(Source: RxNorm / NLM)'
    },
    expression: {
      title: 'RxNorm Concepts and Relationships',
      paragraph1: 'RxNorm provides multiple concept types and relationships (e.g., ingredient, clinical drug, branded drug) to support mapping, integration, and search of medication data.'
    },
    videos: {
      title: 'RxNorm Course Videos',
      description: 'Want to learn more about RxNorm? Visit the "Seminar" section of Taiwan Smart Healthcare School to browse related course videos. No registration is required to watch them directly.',
      ctaLabel: 'Go To Taiwan Smart Healthcare School '
    }
  },
  footer: {
    planOrigin: 'Plan Origin',
    seminar: 'Seminar',
    planCourses: 'CFP Requirements',
    fourDomains: 'Four Domain Programs',
    termsAndPolicies: 'Privacy Policy & Terms of Service',
    termsOfService: 'Privacy Policy & Terms of Service',
    allCourses: 'All Courses',
    medicalInfo: 'Medical Information Program',
    medicalAI: 'Medical AI Program',
    medicalSecurity: 'Medical Security Program',
    medicalBigData: 'Medical Big Data Program',
    securityPolicy: 'Privacy Policy & Terms of Service',
    privacyPolicy: 'Privacy Policy & Terms of Service',
    privacyAndTerms: 'Privacy Policy & Terms of Service',
    schoolName: 'Taiwan Smart Healthcare School',
    introAndHistory: 'Intro & History',
    ministerIntro: "Minister's Message",
    viceMinisterIntro: "Vice Minister's Message",
    directorIntro: "Director's Message",
    customerService: 'Support Form',
    latestNews: 'Latest News',
    platformIntro: 'About Platform',
    platformBackground: 'Background',
    expertDirectory: 'Expert Directory',
    snomedCtIntro: 'RxNorm',
    whatIsSnomedCt: 'What is RxNorm',
    snomedCtEducation: 'RxNorm Education',
    rxnormIntro: 'RxNorm',
    rxnormEducation: 'RxNorm Education',
    training: 'Workshop Courses',
    workshopCourses: 'Workshop Courses',
    workshopMaterials: 'Workshop Materials',
    certificationApply: 'Certification Apply',
    taiwanStandards: 'Taiwan Standards',
    standardAnnouncements: 'Standard Announcements',
    standardProposals: 'Standard Proposals',
    datasets: 'Datasets',
    terminologySearch: 'Terminology Search',
    terminologyTaiwan: 'Taiwan Version',
    terminologyInternational: 'International Version',
    supportCenter: 'Support Center'
  },
  examModal: {
    title: 'Before starting the exam, please note the following',
    cameraInstruction: 'Please ensure the image is clear. If the screen is black, check camera settings',
    cameraError: 'Unable to activate camera',
    retryCamera: 'Retry',
    safetyRules: {
      rule1: '1. During the exam, your camera will be used to take photos to confirm that you are the one taking the test.',
      rule2: '2. The photos are only used for identity verification for this exam and will not be used for other purposes, and will be properly kept according to the platform',
      rule3: '3. Please ensure your face is clearly visible and avoid sensitive information or distractions in the background.',
      rule4: '4. If the device cannot activate the camera, you will not be able to take this exam.',
      rule5: '5. If the camera is not detected during the exam, the system will automatically pause the test. Please ensure smooth recording throughout the process.'
    },
    privacyPolicy: 'Privacy Policy',
    privacyPolicy2: 'properly safeguards your personal information.',
    cancelButton: 'Back to Previous Page',
    startButton: 'Agree and Start Exam',
    cameraPermissionError: 'Unable to take photo, please check camera permissions'
  },
  courseMonitoringModal: {
    title: 'Before starting the course, please note the following',
    cameraInstruction: 'Please ensure the image is clear. If the screen is black, check camera settings',
    cameraError: 'Unable to activate camera',
    retryCamera: 'Retry',
    safetyRules: {
      rule1: '1. During the course, your camera will be used to take photos to confirm that you are the one attending.',
      rule1_1: 'Please ensure your face is clearly visible and avoid sensitive information or distractions in the background.',
      rule1_2: 'If the camera is not detected during the test, the system will automatically pause the test. Please ensure smooth recording throughout the process.',
      rule2: '2. The photos are only used for identity verification for this exam and will not be used for other purposes, and will be properly kept according to the platform',
      rule3: '3. If the device cannot activate the camera, you will not be able to take this test.',
      rule4: '4. During viewing, the system will randomly pop up confirmation windows to ensure you are online.',
      rule5: '5. The viewing time must reach the video duration before you can take the test. Please watch the complete course content.'
    },
    privacyPolicy: 'Privacy Policy',
    privacyPolicy2: 'properly safeguards your personal information',
    cancelButton: 'Back to Previous Page',
    startButton: 'Agree and Start Course'
  },
  planOrigin: {
    title: 'Plan Origin',
    keyPerson: {
      photoAlt: 'Director Photo'
    },
    error: {
      loadFailed: 'Failed to load plan origin content',
      loadError: 'An error occurred while loading plan origin content'
    }
  },
  directorIntro: {
    title: 'Message from the Director',
    keyPerson: {
      title: 'Director of Health and Welfare',
      name: '李建璋',
      engName: 'Chien-Chang Lee'
    },
    section1: {
      title: 'Future: Software Defines Healthcare',
      content: 'Software now defines healthcare. A single platform can write notes, guide treatment, and read images, but it takes cross-disciplinary talent. Traditional training takes over 10 years, so hospitals worldwide are creating the Chief Medical Information Officer role.'
    },
    section2: {
      title: 'The Four Major Roles of Chief Medical Information Officers',
      content: 'In recent years, Chief Medical Information Officers have even been subdivided into four major roles. The first role is Chief Medical Security Officer, responsible for maintaining the healthcare information security environment. The second is Chief Medical Information Officer, focusing on clinical decision systems centered around electronic medical records and electronic medical record interoperability. The third is called Chief Medical Data Officer. Data is the oil of smart healthcare, and this data needs governance, so a Chief Medical Data Officer is established to handle these matters. The last one is Chief Medical AI Officer. We know that AI technology is advancing very rapidly, and AI also faces many ethical and implementation issues, which also require an interdisciplinary person to handle these matters. However, these contents are difficult to complete training in a single program at a single school. It must combine online education and training, and even be able to implement hands-on, in order to be considered complete training.'
    },
    section3: {
      title: 'The Training Model of Taiwan Smart Healthcare School',
      content: 'Therefore, the Information Department organizes such training courses. We cooperate with internationally renowned smart healthcare hospitals. After students complete their education online and pass the selection process, they can go to overseas hospitals for internships. When they return to Taiwan, they implement the work in their own healthcare fields. This completes the full training course, and the Ministry of Health and Welfare can then award relevant qualifications. The establishment of Taiwan Smart Healthcare School enriches interdisciplinary talents for major hospitals and lays a good foundation for national smart healthcare.'
    }
  },
  ministerIntro: {
    title: 'Message from Minister',
    paragraph1: 'As healthcare rapidly moves towards smart solutions globally, we stand at a pivotal turning point. Medical services are no longer just about clinical diagnosis and treatment; they are gradually shifting towards a decision-making model centered on "data" and "technology." From the interoperability of electronic medical records, the application of medical AI, and big data analytics to clinical decision support systems, every technology is redefining the landscape of healthcare. To make these innovations truly land and improve the quality of patient care, "talent" is the most crucial foundation.',
    paragraph2: 'Taiwan possesses long-accumulated advantages in medical quality and public health information integration. However, in a rapidly changing technological environment, we still need more talents capable of crossing the boundaries between clinical practice and technology to assist medical institutions in driving digital transformation. Therefore, we have launched the "Taiwan Smart Healthcare School," a national-level platform designed to systematically cultivate professionals in medical informatics and smart healthcare.',
    paragraph3: 'This platform combines professional online courses from home and abroad, AI interactive quizzes, and digital certification, allowing learners to acquire core smart healthcare capabilities anytime, anywhere. At the same time, through cooperation with top international hospitals, we are establishing mechanisms for cross-border practical training and talent exchange. In the future, Taiwan\'s medical informatics talents will go global through this platform, bringing the world\'s latest smart healthcare thinking and experience back to Taiwan, transforming them into practical clinical changes.',
    paragraph4: 'The promotion of smart healthcare is a long journey, but it is also an important opportunity for Taiwan to move towards global leadership. We expect the "Taiwan Smart Healthcare School" to become a platform for gathering experts, cultivating talents, and promoting cross-sector cooperation, enabling every healthcare provider to provide more precise, safer, and patient-centered medical services with the added value of technology.',
    paragraph5: 'We invite everyone to join us in building a smart healthcare ecosystem that leads future generations.',
    keyPerson: {
      title: 'Minister of Health and Welfare',
      name: 'Shih, Chung-Liang',
      engName: 'Chung-Liang Shih'
    }
  },
  viceMinisterIntro: {
    title: 'Message from Vice Minister',
    paragraph1: 'Digital transformation in healthcare is not just a technical upgrade, but a readjustment of the entire healthcare system. In recent years, we have seen many hospitals face new challenges in electronic medical records, information security, data governance, and AI applications. Therefore, we clearly understand: only talents with cross-disciplinary capabilities can truly implement smart healthcare on the front line.',
    paragraph2: '"Taiwan Smart Healthcare School" was established based on this need. This is not just an online education platform, but a complete training system constructed by combining policy direction, international experience, and clinical needs. The curriculum covers four major areas: medical information security, medical big data, medical AI, and medical information management. Through AI interactive quizzes and situational learning, students not only "know" but can truly "do".',
    paragraph3: 'This platform also combines talent cultivation with system design, using "training certification" and "international practical training" as dual axes to provide students with a clear growth path. After completing courses and certification, outstanding students will be able to go to foreign hospitals for practical training, learning how to promote data governance, clinical AI, or various innovative smart healthcare applications in a clinical environment.',
    paragraph4: 'I believe that "Taiwan Smart Healthcare School" will become an important driving force for hospital digital transformation and bring new energy to Taiwan\'s healthcare system. Through a systematic, long-term, and cross-border cooperative talent cultivation model, we will gradually build a professional ecosystem capable of supporting medical needs in the AI era, enabling every hospital to have sufficient talent and capabilities to move forward with peace of mind when facing rapidly changing technologies.',
    paragraph5: 'I look forward to every student joining the Smart Healthcare School becoming a core talent leading the development of smart healthcare in Taiwan, and let us join hands to create a safer and higher-quality health environment.',
    keyPerson: {
      title: 'Permanent Vice Minister of Health and Welfare',
      name: 'Chuang, Jen-Hsiang',
      engName: 'Jen-Hsiang Chuang'
    }
  },
  allCourses: {
    browseByCategory: 'Browse by Category'
  },
  courseDetail: {
    courseDetail: 'Course Details',
    courseIdNotFound: 'Course ID not found',
    noNeedsRegistration: 'Non-trained students do not need to register to attend this course, but they cannot accumulate credits.',
    enrollNow: 'Enroll Now',
    continueLearning: 'Continue',
    takeExam: 'Take Exam',
    viewRecord: 'View Record',
    favorite: 'Favorite',
    favorited: 'Favorited',
    courseCategory: 'Course Category',
    courseUser: 'Course User',
    courseInstructor: 'Course Instructor',
    credits: 'Credits',
    is_mandatory: 'Course Nature',
    mandatory: 'Mandatory',
    optional: 'Optional',
    courseLevel: 'Course Level',
    certificateIssued: 'Certificate Issued',
    hasCertificate: 'Has Certificate',
    noCertificate: 'No Certificate',
    courseIntro: 'Workshop Introduction',
    timeLocation: 'Time & Location',
    workshopAgenda: 'Workshop Agenda',
    intro: 'Intro',
    chapterList: 'Chapter List',
    chapter: 'Chapter',
    aboutInstructor: 'About Instructor',
    instructor: 'Instructor',
    getCertificate: 'Get Certificate',
    certificate: 'Certificate',
    totalDuration: 'Total Duration: ',
    noChaptersSet: 'No chapter content has been set for this course',
    uncategorized: 'Uncategorized',
    failedToGetCourseData: 'Failed to get course data',
    errorGettingCourseDetail: 'Error occurred while getting course details',
    pleaseLoginToEnroll: 'Please login before enrolling',
    noAvailableChapterFound: 'No available chapter found',
    cmioCourseRequiresCompleteProfile: 'CMIO course enrollment requires complete profile',
    enrollmentFailed: 'Enrollment failed, please try again',
    pleaseAgreeToTerms: 'Please agree to the terms before continuing',
    courseContentLoaded: 'Course content loaded',
    failedToLoadCourseContent: 'Failed to load course content, please try again',
    preparingToStartCourse: 'Preparing to start course...',
    enteringCourse: 'Entering course...',
    certificateIssuance: 'Certificate Issuance',
    getCertificate: 'Get Certificate',
    noInstructorData: 'No instructor data provided for this course',
    formalLearningRecord: 'Can be used as formal learning record',
    enhanceResume: 'Can be included in resume to enhance career competitiveness',
    youWillGetCertificate: 'Upon completion of this course, you will earn credits',
    notYetExam: 'You need finish course then you can take exam'
  },
  findCourse: {
    courseCatelog: 'Course Catalog',
    nature: 'Nature',
    creditUnit: 'Credits',
    creditRange: 'Credit Range',
    courseTopic: 'Course Topic',
    sortNewest: 'Sort: Newest',
    sortPopular: 'Sort: Popular',
    sortName: 'Sort: Name',
    filter: 'Filter',
    sort: 'Sort',
    popular: 'Popular',
    newest: 'Newest',
    name: 'Name',
    beginner: 'Beginner',
    intermediate: 'Intermediate',
    advanced: 'Advanced',
    noLevel: 'No Level',
    credit: 'Credit',
    topic: 'Topic',
    mandatory: 'Mandatory',
    optional: 'Optional',
    noRegistrationCourse: 'No Registration Required',
    CMIOCourse: 'CMIO Course',
    noMatchingCourses: 'No matching courses found. Please try different filter options.',
    getFavoriteCoursesFailed: 'Failed to get favorite courses'
  },
  home: {
    carousel: {
      welcomeTitle: 'Welcome to Taiwan Smart Healthcare School',
      welcomeSubtitle: 'Data-Driven Smart Healthcare',
      retry: 'Retry'
    },
    snomedCt: {
      title: 'What is LOINC?',
      subtitle: 'LOINC (Logical Observation Identifiers Names and Codes)',
      desc1: 'A universal identifier and naming system for laboratory tests, clinical measurements, and observations.',
      desc2: 'Enables consistent representation and data exchange across systems and organizations.',
      featuresTitle: 'Features of LOINC',
      features: {
        f1: {
          title: 'Standardized Observations [Pending Confirmation]',
          desc: 'Encodes tests and observations with consistent identifiers and names, reducing ambiguity between different systems. [Pending Confirmation]'
        },
        f2: {
          title: 'Interoperability Support [Pending Confirmation]',
          desc: 'Helps healthcare systems transmit and interpret observation data accurately, improving cross-organization data exchange. [Pending Confirmation]'
        },
        f3: {
          title: 'Extensible Use Cases [Pending Confirmation]',
          desc: 'Applicable to CDS, research, and public health to support reuse and advanced analytics. [Pending Confirmation]'
        }
      },
      learnMore: 'Learn More'
    },
    trainingCert: {
      title: 'Training & Certification',
      workshops: {
        title: 'Workshop Courses',
        desc: '[Please provide intro text]',
        btn: 'Go to Courses'
      },
      materials: {
        title: 'Official Workshop Materials',
        desc: '[Please provide intro text]',
        btn: 'Go to Materials'
      },
      certification: {
        title: 'Certification Application Area',
        desc: '[Please provide intro text]',
        btn: 'Go to Area'
      }
    },
    taiwanStandard: {
      title: 'Taiwan Standards',
      desc: 'Introduction text',
      announcement: {
        title: 'Standards Announcement Area',
        desc: 'This section publishes the latest updates of RxNorm compiled by the U.S. National Library of Medicine (NLM) and updates of domestic corresponding codes. RxNorm provides standardized names and unique identifiers for clinical drugs (including generic and brand-name drugs), and is one of the important standards designated for use in electronic medical information exchange systems.\n\nAnnouncements Cover:\n• Version Update Information: Synchronized release of RxNorm update information every January and July to ensure drug standard names are aligned globally.\n• Vocabulary Linking Dynamics: Announcements of connection updates between RxNorm and major drug vocabularies such as First Databank, Micromedex, and Multum, assisting in information coordination across different software systems.\n• Educational Area Information: Providing the latest RxNorm related courses, APP development instructions, and practical application seminar announcements.',
        btn: 'Go to Announcements'
      },
      standardProposals: {
        title: 'Standard Proposals',
        desc: 'To improve the coverage of domestic clinical drug standard coding, this section provides a channel for standardization proposals. For RxNorm codes not covered by current coding (including international standards or local mapping codes), they can be included in localized implementation guides or recommended to international organizations after expert review.',
        btn: 'Go to Standard Proposals'
      },
      dataset: {
        title: 'Dataset',
        desc: '[Please provide intro text]',
        btn: 'Go to Dataset'
      }
    },
    termSearch: {
      title: 'Terminology Search',
      desc: 'Introduction text',
      international: {
        title: 'International Edition',
        desc: '[Please provide text]',
        btn: 'Go to International Edition'
      },
      taiwan: {
        title: 'Taiwan Edition',
        desc: '[Please provide text]',
        btn: 'Coming Soon'
      }
    }
  },
  sidebar: {
    taiwanSmartHealthSchool: 'Taiwan Smart Healthcare School',
    dashboard: 'Dashboard',
    certificates: 'Certificate Download',
    myCourses: 'My Courses',
    inProgressCourses: 'In Progress',
    completedCourses: 'Completed',
    favoriteCourses: 'Favorites',
    myLearningRecord: 'Learning Record',
    instructor: 'Instructor',
    trackedInstructors: 'Followed',
    certificateStatsAndDownload: 'Certificate Download',
    examResultsQuery: 'Exam Results',
    user: 'User',
    profile: 'Account Settings',
    accountCenter: 'Account Center',
    logout: 'Logout',
    websiteHomepage: 'Homepage',
    language: 'Language',
    chinese: '繁體中文',
    english: 'English'
  },
  instructor: {
    instructorPhoto: 'Instructor Photo',
    instructorName: 'Instructor Name',
    position: 'Position',
    loadingInstructorInfo: 'Loading instructor information...',
    reloadInstructor: 'Reload',
    defaultDescription: 'Instructor description will be displayed here, including professional background, teaching experience and other relevant information.',
    failedToLoadInstructor: 'Failed to load instructor information',
    instructorNotFound: 'Instructor information not found',
    networkError: 'Network connection error, please check your connection and try again',
    unknownError: 'An unknown error occurred, please try again later'
  },
  loginCard: {
    title: 'Login',
    email: 'Email',
    emailRequired: 'Please enter your email',
    emailInvalid: 'Please enter a valid email format',
    emailPlaceholder: 'Please enter your email',
    password: 'Password',
    passwordRequired: 'Please enter your password',
    passwordPlaceholder: 'Please enter your password',
    rememberMe: 'Remember me',
    forgotPassword: 'Forgot password',
    loginButton: 'Login',
    noAccount: 'Don\'t have an account?',
    register: 'Register',
    loginSuccess: 'Login successful!',
    checkEmail: 'Please check your email',
    checkPassword: 'Please check your password',
    accountNotFound: 'Account does not exist',
    incorrectPassword: 'Incorrect password',
    tooManyAttempts: 'Too many login attempts, please try again later',
    serverNoResponse: 'Server no response, please check your network connection',
    loginRequestFailed: 'Login request failed',
    loginFailed: 'Login failed, please try again later',
    twoFactorRequired: 'Login requires two-factor authentication, please enter verification code',
    twoFactorTitle: 'Two-Factor Authentication',
    twoFactorDescription: 'Please enter the verification code you received:',
    twoFactorPlaceholder: 'Enter 8-digit verification code',
    twoFactorSubmit: 'Confirm',
    twoFactorCancel: 'Cancel',
    twoFactorInvalid: 'Verification code is incorrect or expired',
    twoFactorTooManyAttempts: 'Too many attempts, please try again later',
    resendCode: 'Resend verification code',
    resendCodeIn: 'Resend available in {seconds} seconds',
    resend2FAError: 'Unable to resend verification code: missing email address',
    resendCodeSuccess: 'Verification code has been resent',
    resendCodeFailed: 'Resend failed',
    resendCodeError: 'Resend failed, please try again later',
    accountNotFound: 'Account does not exist',
    emailFormatError: 'Email format error',
    serverError: 'Server error, please try again later',
    resendRequestFailed: 'Resend request failed'
  },
  resendEmail: {
    forgotPassword: 'Forgot password',
    sendResetLinkBtn: 'Send',
    enterEmail: 'Please enter your email,',
    sendResetLink: 'we will send you a password reset link.',
    email: 'Email',
    enterEmailPlaceholder: 'Please enter your email',
    backToLogin: 'Back to Login',
    sending: 'Sending...',
    pleaseEnterEmail: 'Please enter your email',
    resetLinkSent: 'Password reset link has been sent to your email',
    sendResetLinkFailed: 'Failed to send password reset link',
    sendResetLinkError: 'An error occurred while sending the password reset link'
  },
  resetPwd: {
    title: 'Reset Password',
    subtitle: 'Please enter a new password (must be at least 8 characters, containing uppercase, lowercase, numbers, and symbols)',
    password: 'New Password',
    confirmPassword: 'Confirm Password',
    passwordRequired: 'Please enter a new password',
    confirmPasswordRequired: 'Please enter the new password again',
    passwordsNotMatch: 'The two passwords do not match',
    submitBtn: 'Reset Password',
    submittingBtn: 'Resetting...',
    backToLogin: 'Back to Login',
    successToast: 'Password reset successfully',
    failedToast: 'Failed to reset password, please try again later',
    invalidLink: 'Invalid password reset link'
  },
  register: {
    title: 'Register',
    welcome: `Welcome to ${SITE_NAME}`,
    email: 'Email',
    emailPlaceholder: 'Please enter your email',
    password: 'Password',
    passwordPlaceholder: 'Please enter your password',
    passwordHint: '8+ chars with upper, lower, number & symbol',
    registerWithEmail: 'Next: Personal Info',
    termsAgreement: 'By registering, you agree to',
    privacyPolicy: 'Privacy Policy & Terms of Service',
    privacyAndTerms: 'Privacy Policy & Terms of Service',
    and: 'and',
    termsOfService: 'Privacy Policy & Terms of Service',
    hasAccount: 'Already have an account?',
    login: 'Login',
    emailRequired: 'Please enter your email',
    emailInvalid: 'Please enter a valid email format',
    passwordRequired: 'Please enter your password',
    passwordInvalid: '8+ chars with upper, lower, number & symbol',
    serverError: 'Registration failed, server response format error',
    registerSuccess: 'Registration successful!',
    registrationFailed: 'Registration failed, server response format is abnormal',
    networkError: 'Network connection error, please check your connection and try again',
    stepEmail: 'Email Verify',
    stepProfile: 'Profile',
    stepPhone: 'Phone Verify',
    stepDone: 'Complete',
    success: 'Registration successful!',
  },
  createAccount: {
    title: 'Create Account',
    subtitle: 'Learn from smart healthcare experts at your own pace.',
    name: 'Name',
    nameRequired: 'Please enter your name',
    namePlaceholder: 'Please enter your name',
    nameInvalid: 'Please enter a valid name',
    role: 'Role',
    roleRequired: 'Please select your role',
    rolePlaceholder: 'Please select your role',
    customRole: 'Custom Role',
    customRoleRequired: 'Please enter your professional role',
    customRolePlaceholder: 'Please enter your role',
    source: 'How did you learn about Taiwan Smart Healthcare School?',
    sourcePlaceholder: 'Please enter your source',
    nextStep: 'Next Step',
    roleOptions: {
      doctor: 'Doctor',
      nurse: 'Nurse',
      vendor: 'Vendor',
      student: 'Student',
      teacher: 'Teacher',
      other: 'Other'
    },
    validation: {
      nameRequired: 'Please enter a valid name',
      roleRequired: 'Please select your role',
      customRoleRequired: 'Please enter your professional role'
    },
    error: {
      loadRoleOptionsFailed: 'Failed to load role options, please try again later'
    }
  },
  createProfile: {
    title: 'Create Account',
    subtitle: 'The following information is only required when applying for credits, physical certificates, or enrolling in CMIO courses. If you don\'t have these needs yet, you can skip this step and fill it in later.',
    photo: {
      halfLengthPhoto: 'Half-length Photo',
      uploadPhoto: 'Upload Photo',
      removePhoto: 'Remove Photo',
      description: 'Please upload a clear half-length photo of yourself for identification purposes during CMIO exams.',
      size: 'Photo size: 150 x 150 px',
      format: 'Photo format: JPG, PNG',
      fileSize: 'File size: Less than 5MB',
      onlyJpgPng: 'You can only upload JPG/PNG format photos!',
    },
    nationality: {
      label: 'Nationality',
      placeholder: 'Please select your nationality',
      helperText: 'For identity verification only, not used for other purposes',
      options: {
        // 亞洲
        taiwan: 'Taiwan',
        china: 'China',
        hongkong: 'Hong Kong',
        macau: 'Macau',
        japan: 'Japan',
        southKorea: 'South Korea',
        northKorea: 'North Korea',
        singapore: 'Singapore',
        malaysia: 'Malaysia',
        thailand: 'Thailand',
        vietnam: 'Vietnam',
        philippines: 'Philippines',
        indonesia: 'Indonesia',
        myanmar: 'Myanmar',
        cambodia: 'Cambodia',
        laos: 'Laos',
        brunei: 'Brunei',
        india: 'India',
        pakistan: 'Pakistan',
        bangladesh: 'Bangladesh',
        sriLanka: 'Sri Lanka',
        nepal: 'Nepal',
        bhutan: 'Bhutan',
        maldives: 'Maldives',
        afghanistan: 'Afghanistan',
        iran: 'Iran',
        iraq: 'Iraq',
        israel: 'Israel',
        palestine: 'Palestine',
        jordan: 'Jordan',
        lebanon: 'Lebanon',
        syria: 'Syria',
        turkey: 'Turkey',
        saudiArabia: 'Saudi Arabia',
        uae: 'UAE',
        kuwait: 'Kuwait',
        qatar: 'Qatar',
        bahrain: 'Bahrain',
        oman: 'Oman',
        yemen: 'Yemen',
        mongolia: 'Mongolia',
        kazakhstan: 'Kazakhstan',
        uzbekistan: 'Uzbekistan',
        turkmenistan: 'Turkmenistan',
        tajikistan: 'Tajikistan',
        kyrgyzstan: 'Kyrgyzstan',

        // 歐洲
        uk: 'United Kingdom',
        ireland: 'Ireland',
        france: 'France',
        germany: 'Germany',
        italy: 'Italy',
        spain: 'Spain',
        portugal: 'Portugal',
        netherlands: 'Netherlands',
        belgium: 'Belgium',
        luxembourg: 'Luxembourg',
        switzerland: 'Switzerland',
        austria: 'Austria',
        denmark: 'Denmark',
        sweden: 'Sweden',
        norway: 'Norway',
        finland: 'Finland',
        iceland: 'Iceland',
        russia: 'Russia',
        ukraine: 'Ukraine',
        belarus: 'Belarus',
        poland: 'Poland',
        czech: 'Czech Republic',
        slovakia: 'Slovakia',
        hungary: 'Hungary',
        romania: 'Romania',
        bulgaria: 'Bulgaria',
        greece: 'Greece',
        serbia: 'Serbia',
        croatia: 'Croatia',
        slovenia: 'Slovenia',
        bosnia: 'Bosnia and Herzegovina',
        montenegro: 'Montenegro',
        northMacedonia: 'North Macedonia',
        albania: 'Albania',
        lithuania: 'Lithuania',
        latvia: 'Latvia',
        estonia: 'Estonia',
        moldova: 'Moldova',
        malta: 'Malta',
        cyprus: 'Cyprus',
        andorra: 'Andorra',
        monaco: 'Monaco',
        sanMarino: 'San Marino',
        vatican: 'Vatican',
        liechtenstein: 'Liechtenstein',

        // 北美洲
        usa: 'United States',
        canada: 'Canada',
        mexico: 'Mexico',
        guatemala: 'Guatemala',
        belize: 'Belize',
        elSalvador: 'El Salvador',
        honduras: 'Honduras',
        nicaragua: 'Nicaragua',
        costaRica: 'Costa Rica',
        panama: 'Panama',
        cuba: 'Cuba',
        jamaica: 'Jamaica',
        haiti: 'Haiti',
        dominicanRepublic: 'Dominican Republic',
        bahamas: 'Bahamas',
        barbados: 'Barbados',
        trinidadTobago: 'Trinidad and Tobago',

        // 南美洲
        brazil: 'Brazil',
        argentina: 'Argentina',
        chile: 'Chile',
        peru: 'Peru',
        colombia: 'Colombia',
        venezuela: 'Venezuela',
        ecuador: 'Ecuador',
        bolivia: 'Bolivia',
        paraguay: 'Paraguay',
        uruguay: 'Uruguay',
        guyana: 'Guyana',
        suriname: 'Suriname',

        // 大洋洲
        australia: 'Australia',
        newZealand: 'New Zealand',
        fiji: 'Fiji',
        papuaNewGuinea: 'Papua New Guinea',
        samoa: 'Samoa',
        tonga: 'Tonga',
        vanuatu: 'Vanuatu',
        solomonIslands: 'Solomon Islands',
        micronesia: 'Micronesia',
        marshallIslands: 'Marshall Islands',
        palau: 'Palau',
        nauru: 'Nauru',
        kiribati: 'Kiribati',
        tuvalu: 'Tuvalu',

        // 非洲
        southAfrica: 'South Africa',
        egypt: 'Egypt',
        nigeria: 'Nigeria',
        kenya: 'Kenya',
        ethiopia: 'Ethiopia',
        ghana: 'Ghana',
        morocco: 'Morocco',
        algeria: 'Algeria',
        tunisia: 'Tunisia',
        libya: 'Libya',
        sudan: 'Sudan',
        southSudan: 'South Sudan',
        uganda: 'Uganda',
        tanzania: 'Tanzania',
        rwanda: 'Rwanda',
        burundi: 'Burundi',
        drCongo: 'Democratic Republic of the Congo',
        congo: 'Republic of the Congo',
        centralAfricanRepublic: 'Central African Republic',
        cameroon: 'Cameroon',
        chad: 'Chad',
        niger: 'Niger',
        mali: 'Mali',
        burkinaFaso: 'Burkina Faso'
      }
    },
    idNumber: {
      label: 'ID Number',
      placeholder: 'Please enter your ID number',
      helperText: 'For credit certification only',
      invalid: 'Please enter a valid ID number (e.g., A123456789)'
    },
    passportNumber: {
      label: 'Passport Number',
      placeholder: 'Please enter your passport number',
      helperText: 'For ID verification only',
      invalid: 'Please enter a valid passport number (6-9 alphanumeric characters)'
    },
    address: {
      label: 'Address',
      placeholder: 'Please enter your address',
      helperText: 'For certificate mailing only'
    },
    buttons: {
      nextStep: 'Next Step',
      skipStep: 'Skip This Step'
    }
  },
  emailValidate: {
    title: 'Please Check Your Inbox',
    subtitle1: 'Click the link we sent to',
    subtitle2: ',',
    subtitle3: 'to set up your account.',
    openGmail: 'Open Gmail',
    openOutlook: 'Open Outlook',
    noEmail: 'No email in inbox or spam folder?',
    resend: 'Resend',
    sending: 'Sending...',
    wrongEmail: 'Wrong email?',
    backToRegister: 'Back to Register',
    useOtherEmail: ' or use another email',
    completeRegistrationFirst: 'Please complete the registration process first',
    waitSeconds: 'Please wait {seconds} seconds before resending',
    verificationEmailResent: 'Verification email has been resent, please check your inbox',
    resendFailed: 'Resend failed',
    resendVerificationEmailFailed: 'Failed to resend verification email'
  },
  verifyEmail: {
    verifying: 'Verifying... Please wait',
    verificationComplete: 'Email Verified',
    welcomeMessage: 'Please continue to complete your personal profile. Your common member account will be activated once completed.',
    continueToProfile: 'Continue to Fill in Personal Profile',
    continueRegistration: 'Continue to complete registration',
    verificationFailed: 'Verification Failed',
    invalidLink: 'Please check if your email link is valid',
    backToHome: 'Back to Home',
    emailVerificationSuccess: 'Email verification successful!',
    verificationFailedRetry: 'Verification failed, please try again',
    verificationError: 'An error occurred during verification',
    cannotGetToken: 'Unable to get Email verification token!'
  },
  checkEmail: {
    checkYourInbox: 'Check Your Inbox',
    clickLinkSentTo: 'Click the link we sent to {email}',
    toCompleteAccountSetup: 'to reset your password.',
    openGmail: 'Open Gmail',
    openOutlook: 'Open Outlook',
    noEmailInInbox: 'No email in inbox or spam folder?',
    loading: 'Loading...',
    resendWithCountdown: 'Resend in {countdown}s',
    resend: 'Resend',
    wrongEmail: 'Wrong email?',
    backToForgotPassword: 'Back to Forgot Password',
    useAnotherEmail: ' or use another email',
    resetLinkResent: 'Reset password link has been resent to your email',
    resendFailed: 'Resend failed',
    resendError: 'An error occurred while resending the reset password link'
  },
  verifyNumber: {
    title: 'Mobile Number Verification',
    subtitle: 'Verify your mobile number to ensure account security and availability',
    mobileLabel: 'Mobile Number',
    mobilePlaceholder: 'Please enter your mobile number',
    sendVerification: 'Send SMS Verification Code',
    errorEmptyMobile: 'Please enter your mobile number',
    errorInvalidFormat: 'Please enter a valid Taiwan mobile number format (e.g., 0912345678)',
    successMessage: 'Verification code has been sent to your mobile',
    errorSubmitFailed: 'Failed to submit basic information',
    errorGeneral: 'Operation failed, please try again later',
    errorTooManyRequests: 'Too many requests, please try again later',
    errorServerError: 'Server error, please try again later'
  },
  verificationCode: {
    mobileLabel: 'Mobile Number',
    codeLabel: 'SMS Verification Code',
    codePlaceholder: 'Please enter the SMS verification code you received',
    agreeText: 'I have read and agree to',
    privacyPolicy: 'Privacy Policy',
    and: 'and',
    termsOfService: 'Terms of Service',
    confirmButton: 'Confirm and Complete Registration',
    resendText: "Didn't receive the verification code?",
    resendLink: 'Resend',
    checkFormValid: 'Please check the form for errors',
    errorEmptyCode: 'Please enter the SMS verification code',
    errorTermsNotAgreed: 'Please agree to the Privacy Policy and Terms of Service',
    successMessage: 'Mobile verification successful',
    errorGetUserInfo: 'Failed to get user information:',
    errorLoginFailed: 'Login failed, please login manually',
    errorVerificationFailed: 'Verification failed, please check if the verification code is correct',
    errorVerification: 'Verification failed:',
    errorGeneral: 'Verification failed, please try again later',
    resendSuccess: 'Verification code has been resent',
    resendFailed: 'Failed to send verification code, please try again later',
    resendError: 'Failed to resend verification code, please try again later',
    agreeToTermsHint: 'Please read the Privacy Policy and Terms of Use first and check to confirm'
  },
  registerComplete: {
    title: 'Registration Complete!',
    subtitle: 'Welcome to Taiwan Smart Healthcare School!',
    descriptionSteps: 'Here you can learn at your own pace from smart healthcare experts.',
    descriptionCourse: 'You can now start learning 《{courseName}》',
    buttonText: 'Enter Taiwan Smart Healthcare School'
  },
  profileEdit: {
    title: 'Edit Profile',
    welcome: 'Welcome! Please complete your personal information.',
    profilePhoto: 'Profile Photo',
    userPhoto: 'User Photo',
    photoPreview: 'Photo Preview',
    photoDescription: 'Upload a clear photo to enhance your profile identification.',
    photoSize: 'Recommended size: 300x300px',
    photoFormat: 'Format: All image formats',
    photoFileSize: 'File size: up to 5MB',
    removePhoto: 'Remove',
    uploadPhoto: 'Upload',
    account: 'Account',
    accountPlaceholder: 'Your account',
    accountHelper: 'Account cannot be modified',
    password: 'Password',
    passwordPlaceholder: 'Enter new password',
    passwordHelper: 'Leave blank to keep current password',
    gender: 'Gender',
    genderPlaceholder: 'Please select your gender',
    genderHelper: 'Used for identity verification',
    genderMale: 'Male',
    genderFemale: 'Female',
    identity: 'Identity',
    identityPlaceholder: 'Please select your identity',
    identityHelper: 'Used for course recommendations and certificate issuance',
    identityStudent: 'Student',
    identityTeacher: 'Teacher',
    identityDoctor: 'Doctor',
    identityNurse: 'Nurse',
    identityVendor: 'Vendor',
    identityOther: 'Other',
    nationality: 'Nationality',
    nationalityPlaceholder: 'Please select your nationality',
    nationalityHelper: 'Used for identity verification',
    nationalIdHelper: 'Used for identity verification',
    saveButton: 'Save',
    skipButton: 'Skip',
    cancelButton: 'Cancel',
    updateFailed: 'Update failed',
    updateFailedRetry: 'Update failed, please try again later',
    checkFormErrors: 'Please check the form for errors',
    imageFormatError: 'Only image formats are allowed!',
    imageSizeError: 'Image size must be less than 10MB!',
    imageUploadSuccess: 'Photo uploaded successfully!',
    imageReadError: 'Failed to read photo!',
    imageRemoved: 'Photo removed',
    fetchUserInfoFailed: 'Failed to get user information, please login again',
    unsavedChangesWarning: 'You have unsaved changes, are you sure you want to leave?',
    unsavedChangesConfirm: 'You have unsaved changes, are you sure you want to leave? All unsaved data will be lost.',
    passportNumber: 'Passport Number',
    passportNumberPlaceholder: 'Please enter your passport number',
    passportNumberHelper: 'For identity verification',
    address: 'Address',
    addressPlaceholder: 'Please enter your address',
    addressHelper: 'For official certificate mailing',
    confirmButton: 'Confirm',
    accountPlaceholder: 'Your account',
    accountHelper: 'Account cannot be modified',
    password: 'Password',
    passwordPlaceholder: 'Enter new password',
    passwordHelper: 'Leave blank to keep current password',
    gender: 'Gender',
    genderPlaceholder: 'Please select your gender',
    genderHelper: 'Used for identity verification',
    genderMale: 'Male',
    genderFemale: 'Female',
    identity: 'Identity',
    identityPlaceholder: 'Please select your identity',
    identityHelper: 'Used for course recommendations and certificate issuance',
    identityStudent: 'Student',
    identityTeacher: 'Teacher',
    identityDoctor: 'Doctor',
    identityNurse: 'Nurse',
    identityVendor: 'Vendor',
    identityOther: 'Other',
    nationality: 'Nationality',
    nationalityPlaceholder: 'Please select your nationality',
    nationalityHelper: 'Used for identity verification',
    saveButton: 'Save',
    skipButton: 'Skip',
    cancelButton: 'Cancel',
    updateFailed: 'Update failed',
    updateFailedRetry: 'Update failed, please try again later',
    checkFormErrors: 'Please check the form for errors',
    imageFormatError: 'Only JPG/PNG format images are allowed!',
    imageSizeError: 'Image size must be less than 5MB!',
    imageUploadSuccess: 'Photo uploaded successfully!',
    imageReadError: 'Failed to read photo!',
    imageRemoved: 'Photo removed',
    fetchUserInfoFailed: 'Failed to get user information, please login again',
    unsavedChangesWarning: 'You have unsaved changes, are you sure you want to leave?',
    unsavedChangesConfirm: 'You have unsaved changes, are you sure you want to leave? All unsaved data will be lost.',
    passportNumber: 'Passport Number',
    passportNumberPlaceholder: 'Please enter your passport number',
    passportNumberHelper: 'For identity verification',
    address: 'Address',
    addressPlaceholder: 'Please enter your address',
    addressHelper: 'For official certificate mailing',
    confirmButton: 'Confirm',
    accountPlaceholder: 'Your account',
    accountHelper: 'Account cannot be modified',
    password: 'Password',
    passwordPlaceholder: 'Enter new password',
    passwordHelper: 'Leave blank to keep current password',
    gender: 'Gender',
    genderPlaceholder: 'Please select your gender',
    genderHelper: 'Used for identity verification',
    genderMale: 'Male',
    genderFemale: 'Female',
    identity: 'Identity',
    identityPlaceholder: 'Please select your identity',
    identityHelper: 'Used for course recommendations and certificate issuance',
    identityStudent: 'Student',
    identityTeacher: 'Teacher',
    identityDoctor: 'Doctor',
    identityNurse: 'Nurse',
    identityVendor: 'Vendor',
    identityOther: 'Other',
    nationality: 'Nationality',
    nationalityPlaceholder: 'Please select your nationality',
    nationalityHelper: 'Used for identity verification',
    saveButton: 'Save',
    skipButton: 'Skip',
    cancelButton: 'Cancel',
    updateFailed: 'Update failed',
    updateFailedRetry: 'Update failed, please try again later',
    checkFormErrors: 'Please check the form for errors',
    imageFormatError: 'Only JPG/PNG format images are allowed!',
    imageSizeError: 'Image size must be less than 5MB!',
    imageUploadSuccess: 'Photo uploaded successfully!',
    imageReadError: 'Failed to read photo!',
    imageRemoved: 'Photo removed',
    fetchUserInfoFailed: 'Failed to get user information, please login again',
    unsavedChangesWarning: 'You have unsaved changes, are you sure you want to leave?',
    unsavedChangesConfirm: 'You have unsaved changes, are you sure you want to leave? All unsaved data will be lost.'
  },
  dashboard: {
    welcome: 'Hi, {name}',
    welcomeSubtitle: 'Welcome to Taiwan Smart Healthcare School',
    student: 'Student',
    completedCourses: 'Completed Courses',
    totalCredits: 'Total Credits',
    certificates: 'Certificates',
    inProgressCourses: 'In Progress Courses',
    hotCoursesRecommendation: 'Hot Courses Recommendation',
    hotCoursesRecommendationDesc: 'Choose a course that interests you and start your learning journey',
    hotCourses: 'Hot Courses',
    favoriteCourses: 'Favorite Courses',
    favoriteCoursesDesc: 'You have favorited {count} courses, start learning now',
    favoriteCoursesEmpty: 'You can favorite courses you are interested in from the course overview',
    platformNotices: 'Platform Notices',
    platformNoticesDesc: 'Stay updated with the latest platform news',
    certificateProgress: 'Certificate Progress',
    certificateProgressDesc: 'Complete core courses to earn certificates',
    certificateName: 'Certificate Name',
    missingCredits: 'Missing Credits',
    course: 'Course',
    progress: 'Progress',
    startLearning: 'Start',
    title: 'Title',
    view: 'View',
    noInProgressCourses: 'No courses in progress',
    noFavoriteCourses: 'No favorite courses',
    noNotices: 'No platform notices',
    exploreCourses: 'Explore Courses',
    userInfoError: 'Unable to get user information, please login again',
    relogin: 'Relogin',
    currentCourses: 'You are currently enrolled in {count} courses, keep it up!'
  },
  learningCourses: {
    title: 'In Progress Courses',
    learningProgress: 'Learning Progress',
    exitCourse: 'Exit Course',
    exploreMoreCourses: 'Explore More Courses',
    noCoursesFound: 'No courses found',
    userInfoError: 'Unable to get user information, please login again',
    relogin: 'Relogin',
    courseRemoved: 'Course removed',
    removeCourseError: 'Unable to remove course, please try again later',
    fetchCoursesError: 'Failed to fetch courses',
    page: 'Page',
    of: 'of',
    confirmExitTitle: 'Are you sure you want to exit the course?',
    confirmExitDescription: 'After exiting, your learning progress and test scores will be cleared.',
    cancel: 'Cancel',
    confirmExit: 'Confirm Exit Course'
  },
  completeCourses: {
    title: 'Completed Courses',
    exportExcel: 'Export Excel',
    nature: 'Nature',
    emptyDescription: "Let's continue with in-progress courses!",
    delete: 'Delete',
    userInfoError: 'Unable to get user information, please login again',
    relogin: 'Relogin',
    courseDeleted: 'Course deleted',
    deleteCourseError: 'Unable to delete course, please try again later',
    fetchCoursesError: 'Failed to fetch completed courses',
    noCoursesFound: 'No completed courses found',
    courseName: 'Course Name',
    progress: 'Progress',
    completionDate: 'Completion Date',
    credits: 'Credits',
    actions: 'Actions',
    page: 'Page',
    of: 'of'
  },
  favoriteList: {
    title: 'Favorite Courses',
    courseName: 'Course Name',
    category: 'Category',
    favoritedAt: 'Favorited At',
    action: 'Action',
    removeFavorite: 'Remove from Favorites',
    emptyMessage: 'You can click the bookmark icon from the course overview',
    emptyMessageEnd: 'to favorite courses you are interested in',
    bookmarkButton: 'Bookmark Button',
    of: 'of',
    userInfoError: 'Unable to get user information, please login again',
    invalidUserData: 'No valid user data returned',
    invalidFavoriteData: 'No valid favorite courses data retrieved',
    fetchFavoritesError: 'Failed to fetch favorite courses',
    removedFromFavorites: 'Removed from favorites',
    removeFavoriteError: 'Failed to remove from favorites, please try again later'
  },
  trackedInstructors: {
    title: 'Tracked Instructors',
    subtitle: 'Manage your tracked instructors',
    emptyText: 'You haven\'t tracked any instructors yet, go track your favorite instructors!',
    instructorName: 'Instructor Name',
    position: 'Position',
    followDate: 'Follow Date',
    action: 'Action',
    unfollow: 'Unfollow',
    follow: 'Follow',
    userInfoError: 'Unable to get user information, please login again',
    followSuccess: 'Followed successfully',
    unfollowSuccess: 'Unfollowed successfully',
    operationFailed: 'Operation failed',
    operationError: 'Operation failed, please try again later',
    fetchFailed: 'Failed to get tracked instructor list',
    fetchError: 'Failed to get tracked instructor list, please try again later'
  },
  courseLearning: {
    noVideoContent: 'This chapter has no video content',
    courseTitle: 'Course Title',
    courseCategory: 'Course Category',
    instructor: 'Instructor',
    credits: 'Credits',
    courseLevel: 'Course Level',
    hasCertificate: 'Has Certificate',
    certificateIssuance: 'Certificate Issuance',
    unit: 'Unit',
    notes: 'Notes',
    handout: 'Handout',
    supplementaryMaterials: 'Supplementary Materials',
    personalNotes: 'Personal Notes',
    noSupplementaryMaterials: 'This chapter has no supplementary materials',
    expandChapterList: 'Expand Chapter List',
    collapseChapterList: 'Collapse Chapter List',
    expandNotesArea: 'Expand Notes Area',
    collapseNotesArea: 'Collapse Notes Area',
    certificateAvailable: 'Certificate Available',
    noCertificate: 'No Certificate',
    downloadPDFMaterials: 'Download PDF Materials',
    pdfMaterial: 'PDF Material',
    downloadPdf: 'Download PDF',
    chapter: 'Chapter',
    lesson: 'Lesson',
    continueWatching: 'Continue Watching',
    autoReturnInSeconds: 'If not clicked, will automatically return to course page in {seconds} seconds',
    areYouStillWatching: 'Are you still watching?',
    clickContinueWatching: 'Please click the "Continue Watching" button to confirm you are still watching the course.',
    continueWatchingButton: 'Continue Watching',
    noteTitlePlaceholder: 'Please enter note title',
    noteContentPlaceholder: 'Please enter note content',
    pleaseEnterNoteContent: 'Please enter note content',
    updating: 'Updating',
    saving: 'Saving',
    saveNote: 'Save Note',
    save: 'Save',
    cancel: 'Cancel',
    editNote: 'Edit Note',
    deleteNote: 'Delete Note',
    noteTimePoint: 'Note Time Point',
    noteActions: 'Note Actions',
    noteSaved: 'Note saved successfully',
    noteSaveFailed: 'Failed to save note',
    noteDeleted: 'Note deleted successfully',
    noteDeleteFailed: 'Failed to delete note',
    noteUpdated: 'Note updated successfully',
    noteUpdateFailed: 'Failed to update note',
    noteTitleRequired: 'Note title is required',
    noteContentRequired: 'Note content is required',
    noteTimeRequired: 'Note time point is required',
    jumpToTime: 'Jump to {time}',
    notesCount: '{count} notes',
    noNotes: 'No notes yet',
    editingNote: 'Editing Note',
    update: 'Update',
    addNote: 'Add Note',
    notesArea: 'Notes Area',
    chapterList: 'Chapter List',
    courseInfo: 'Course Information',
    videoPlayer: 'Video Player',
    materialsArea: 'Materials Area',
    returnToCourse: 'Return to Course',
    previousChapter: 'Previous Chapter',
    nextChapter: 'Next Chapter',
    loadingVideo: 'Loading video...',
    videoLoadError: 'Failed to load video',
    networkError: 'Network error, please check your connection',
    serverError: 'Server error, please try again later',
    unauthorized: 'Please login to access this course',
    courseNotFound: 'Course not found',
    chapterNotFound: 'Chapter not found',
    invalidCourseData: 'Invalid course data',
    fetchCourseError: 'Failed to fetch course information',
    fetchProgressError: 'Failed to fetch learning progress',
    updateProgressError: 'Failed to update learning progress',
    saveProgressError: 'Failed to save learning progress',
    courseCompleted: 'Course completed!',
    chapterCompleted: 'Chapter completed!',
    congratulation: 'Congratulations!',
    youHaveCompleted: 'You have completed this course',
    returnToDashboard: 'Return to Dashboard',
    continueLearning: 'Continue',
    learningProgress: 'Learning Progress',
    completedChapters: 'Completed Chapters',
    totalChapters: 'Total Chapters',
    is_mandatory: 'Is Mandatory',
    mandatory: 'Mandatory',
    optional: 'Optional',
    progressPercentage: 'Progress: {percentage}%',
    estimatedTime: 'Estimated Time: {time}',
    actualTime: 'Actual Time: {time}',
    timeFormat: '{hours}h {minutes}m {seconds}s',
    timeFormatShort: '{hours}:{minutes}:{seconds}',
    quiz: 'Quiz',
    completionProgress: 'Completion Progress',
    completedViewProgress: 'Completed! View Progress',
    deleteFailed: 'Delete failed',
    cameraPermissionError: 'Unable to get camera permission, please ensure the website is allowed to use the camera',
    cameraProblemError: 'Camera problem, please check permission settings',
    cameraPermissionRequired: 'Please allow the website to use camera permissions',
    quizNotStarted: 'Not Started',
    quizWatching: 'Watching',
    quizUnlocked: 'Quiz Unlocked',
    quizLockedButton: 'Finish Watching to Unlock Quiz',
    quizStartButton: 'Start Quiz',
    cameraNotFoundError: 'Camera device not found, please ensure the camera is connected',
    cameraDisconnectedError: 'Camera disconnected, course will automatically end',
    cameraNotStarted: 'Camera not started',
    cameraDisabled: 'Camera disabled',
    cannotCreatePhoto: 'Unable to create photo',
    cameraNotEnabledError: 'Camera not enabled, please confirm the camera is properly connected',
    cameraAbnormalAlert: 'Camera Abnormal Alert',
    cameraAbnormalContent: 'Camera abnormal (black screen) detected, please check: remove camera lens cover or obstructions, ensure the camera is not blocked, check if the camera is working properly. Course monitoring will continue to use the current photo for recording.',
    cannotGetValidPhoto: 'Unable to get valid photo',
    autoExitDueToInactivity: 'Automatically exited viewing due to long period of inactivity'
  },
  courseViewWithoutReg: {
    noVideoContent: 'This chapter has no video content',
    courseTitle: 'Course Title',
    courseCategory: 'Course Category',
    credits: 'Credits',
    courseLevel: 'Course Level',
    certificateIssuance: 'Certificate Issuance',
    instructor: 'Instructor',
    unit: 'Unit',
    handout: 'Handout',
    downloadPDFMaterials: 'Download PDF Materials',
    pdfMaterials: 'PDF Materials',
    downloadPdf: 'Download PDF',
    chapter: 'Chapter',
    lesson: 'Lesson',
    is_mandatory: 'Is Mandatory',
    mandatory: 'Mandatory',
    optional: 'Optional',
    noSupplementaryMaterials: 'This chapter has no supplementary materials',
    expandChapterList: 'Expand Chapter List',
    collapseChapterList: 'Collapse Chapter List',
    expandNotesArea: 'Expand Notes Area',
    collapseNotesArea: 'Collapse Notes Area',
    certificateAvailable: 'Certificate Available',
    noCertificate: 'No Certificate',
    courseInfo: 'Course Information',
    videoPlayer: 'Video Player',
    materialsArea: 'Materials Area',
    chapterList: 'Chapter List',
    returnToCourse: 'Return to Course',
    previousChapter: 'Previous Chapter',
    nextChapter: 'Next Chapter',
    loadingVideo: 'Loading video...',
    videoLoadError: 'Failed to load video',
    networkError: 'Network error, please check your connection',
    serverError: 'Server error, please try again later',
    courseNotFound: 'Course not found',
    chapterNotFound: 'Chapter not found',
    invalidCourseData: 'Invalid course data',
    fetchCourseError: 'Failed to fetch course information',
    unauthorized: 'Please login to access full course content',
    previewMode: 'Preview Mode',
    previewModeDesc: 'You are currently in preview mode. Register to access full course content.',
    registerNow: 'Register Now',
    alreadyHaveAccount: 'Already have an account?',
    loginHere: 'Login here',
    freePreview: 'Free Preview',
    fullCourseAccess: 'Full Course Access',
    featuresComparison: 'Features Comparison',
    previewFeatures: 'Preview Features',
    fullFeatures: 'Full Features',
    watchVideos: 'Watch Videos',
    viewMaterials: 'View Materials',
    takeNotes: 'Take Notes',
    earnCertificate: 'Earn Certificate',
    trackProgress: 'Track Progress',
    lifetimeAccess: 'Lifetime Access',
    mobileFriendly: 'Mobile Friendly',
    customerSupport: 'Customer Support',
    creditsUnit: 'Credits',
    play: 'Play',
    selectChapterToStart: 'Please select a chapter from the left to start learning',
    expand: 'Expand',
    collapse: 'Collapse',
    courseVideo: 'Course Video',
    noChapterContent: 'This course has no chapter content, will return to course detail page',
    notSpecified: 'Not Specified',
    unableToGetCourseData: 'Unable to get course data',
    loadCourseFailed: 'Failed to load course, please try again'
  },
  // 2026-08-06: SMS Auth replaces email verification
  smsAuth: {
    registerTitle: 'Enter Phone Verification Code',
    registerSubtitle: 'A verification code has been sent to your phone {phone}',
    resetTitle: 'Reset Password',
    resetSubtitle: 'Enter the verification code sent to your phone to reset your password',
    phoneLabel: 'Phone Number',
    phonePlaceholder: 'Enter your phone number (e.g. 0912345678)',
    codeLabel: '6-digit Verification Code',
    codePlaceholder: 'Enter the 6-digit code from the SMS',
    sendCode: 'Send Code',
    submitCode: 'Submit Code',
    resendCode: 'Resend Code',
    resendSuccess: 'Verification code has been resent',
    resendIn: 'Resend in {seconds}s',
    bindTitle: 'Bind Phone Number',
    bindSubtitle: 'Please bind your phone number to continue using the service',
    bindSubmit: 'Complete Binding',
    newPasswordLabel: 'New Password',
    newPasswordPlaceholder: 'Enter your new password',
    confirmPasswordLabel: 'Confirm New Password',
    confirmPasswordPlaceholder: 'Re-enter your new password',
    resetSubmit: 'Reset Password',
    helpText: 'Didn\'t receive it? Please check your SMS center or contact customer service',
    errorPhoneFormat: 'Invalid phone number format',
    errorCodeInvalid: 'Invalid or expired verification code',
    errorCodeExpired: 'Verification code expired, please resend',
    errorRateLimit: 'Too many requests, please try again later',
    errorPhoneAlreadyUsed: 'This phone number is already in use',
    errorPhoneNotBound: 'This phone number is not bound to any account',
    errorEmailMissing: 'Registration email not found, please register again',
    successRegister: 'Phone verified, account activated',
    successReset: 'Password reset successful, please log in with your new password',
    successBind: 'Phone binding successful'
  }
};

export default replaceBrand(messages);
